import tableRooms from './tableRooms';

export default {
  title: 'Space Management',
  attributeName: 'rooms',
  getURL: 'mainHubs/mainHubId/roomsPaginated',
  createURL: 'mainHubs/mainHubId/rooms',
  updateURL: 'mainHubs/mainHubId/rooms',
  removeURL: 'mainHubs/mainHubId/rooms',
  idAttribute: 'id',
  sessionParams: ['mainHubId'],
  tableConfig: tableRooms,
  removeNameField:'name',
  removeText:'You are about to remove the sport room with name ##name##.',
  noArea: true,
  autoUpdate: true,
  revalidate: true,
};
